<template>
  <section class="actionbar">
    <div class="action-list">
      <ul class="action-others" v-if="isAllPayType">
        <!-- 旧的支付方式：只支持全额付款 -->
        <li>
          <span>实付款：</span>
          <p>
            <i>&yen;</i><span>{{ price }}</span>
          </p>
        </li>
      </ul>
      <div class="action-prepay" v-else>
        <div class="prepay">
          <span>预付定金：</span>
          <span>&yen;{{ prePrice }}</span>
        </div>
        <div class="nextpay">月嫂上户前再付：&yen;{{ nextPrice }}</div>
      </div>
      <button class="btns btn-pink" v-if="canCreateOrder" @click="confirmBuy">
        提交订单
      </button>
      <button class="btns btn-grey" v-else>提交订单</button>
      <!-- <button class="btns btn-pink" v-else @click="showReason">立即支付</button> -->
    </div>
    <!-- 不要删除-->
    <div class="menu_wkBox_back_box"></div>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Msgbox } from 'kf-component-vue'

import { E_PROMOTION_TYPE } from '@/config'
import { isNonEmptyArray, isNullOrEmpty } from '@/utils'
import http from '@/plugins/http'
import { setOrderId } from '@/business/order/confirmParams'
import { round } from 'lodash'
import { isMiniprogram, isWeixin } from 'kwsdk'
import { MINI_APPID_XYZHG, MINI_APPID_TCHQZ } from '@/constants/appId'

export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    //选填的邀请码和备注/服务天数
    fillIn: {
      type: Object,
      default: () => {}
    },
    isAllPayType: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('confirmYuesao', ['depList']),
    ...mapState(['selectedCoupon', 'couponList', 'selectedAddress']),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo,
      /**
       * 满赠活动信息
       * 满赠必传
       * @returns {{activityId,giveSkuId,giveSpuId,giveSkuName,giveSpuName}}
       */
      promotionGiveVoList(state) {
        console.log('state.promotionInfo :>> ', state.promotionInfo)
        const { promList } = state.promotionInfo
        if (isNullOrEmpty(promList) || !isNonEmptyArray(promList)) return []
        let t = promList.filter(x => +x.type === E_PROMOTION_TYPE.REWARD_GIFT)
        if (isNonEmptyArray(t)) {
          const tmpArr = []
          t.forEach(x => {
            const {
              giftInfo: { skuId, skuName, spuId, spuName, refOrder, specSpu },
              promotionName,
              ruleId
            } = x
            tmpArr.push({
              activityId: ruleId,
              giveSkuId: skuId,
              giveSpuId: spuId,
              giveSkuName: skuName,
              giveSpuName: spuName,
              promotionName,
              refOrder: refOrder,
              endTime: x.endTime,
              specSpu: specSpu
            })
          })

          return tmpArr
        }
        return []
      }
    }),
    commonPrice() {
      if (this.product && this.product.priceInfo) {
        return +this.product.priceInfo.price
      } else {
        return 0
      }
    },
    price() {
      let price = ''
      if (this.product && this.product.priceInfo) {
        if (this.selectedCoupon && this.selectedCoupon.couponId) {
          price =
            this.selectedCoupon.couponAmount >= this.product.priceInfo.price
              ? 0
              : this.product.priceInfo.price - this.selectedCoupon.couponAmount
        } else {
          price = this.product.priceInfo.price
        }
        this.setOrderPayPrice(price)
        return `${price / 100}`
      }
    },
    //预付定金
    prePrice() {
      let price = 0
      if (
        this.product &&
        this.product.skuInfo &&
        this.product.skuInfo.payPeriodInfo &&
        this.product.skuInfo.payPeriodInfo.paymentDepositPrice
      ) {
        price = this.product.skuInfo.payPeriodInfo.paymentDepositPrice
      }

      if (price < 0) price = 0
      return `${price / 100}`
    },
    //尾款
    nextPrice() {
      let price = this.price * 100 - this.prePrice * 100
      if (price < 0) price = 0
      return `${round(price / 100, 2)}`
    },
    canCreateOrder() {
      let isValid = true
      this.depList.every(item => {
        const b = !!item.value
        if (!b) {
          isValid = false
        }
        return b
      })
      isValid = isValid && this.isNotNullObject(this.selectedAddress)
      isValid = isValid && !!this.fillIn.inviteCode
      return isValid
    },
    remark() {
      return this.fillIn.remark
    },
    inviteCode() {
      return this.fillIn.inviteCode
    },
    serviceDays() {
      return this.fillIn.serviceDays
    }
  },
  data() {
    return {
      fetching: false
    }
  },
  methods: {
    ...mapMutations(['setOrderPayPrice']),
    isNotNullObject(obj) {
      return Object.keys(obj).length > 0
    },
    //参数验证
    validParams() {
      if (this.inviteCode.trim() && !this.fillIn.inviteName) {
        this.$$toast({
          transition: false,
          message: '请输入正确的服务顾问',
          autoClose: true,
          duration: 3000
        })
        return false
      }
      if (this.fillIn && this.fillIn.remark) {
        const num = this.fillIn.remark.length
        if (num > 150) {
          this.$$toast({
            transition: false,
            message: '备注信息不能超过150个字',
            autoClose: true,
            duration: 3000
          })
          return false
        } else {
          return true
        }
      }
      return true
    },
    confirmBuy() {
      if (!this.validParams()) {
        return false
      }
      try {
        trackClick('SUBMIT_FORM')
        const price = this.commonPrice - this.selectedCoupon.couponAmount <= 0
        if (price) {
          Msgbox({
            title: '',
            message: '您使用的优惠券金额≥商品金额，确认使用该优惠券支付？',
            confirmButtonText: '确定',
            showCancelButton: true,
            confirmButtonClass: 'confirmButton',
            type: 'confirm',
            action: msgbox => {
              this.doPay()
            }
          })
        } else {
          this.doPay()
        }
      } catch (e) {
        this.doPay()
      }
    },
    async doPay() {
      if (this.fetching) {
        return
      }

      this.fetching = true
      const { uid, skey } = await this.$$ensureLogin()
      const shareKeyObj = this.$route.query.hserecomkey || ''
      let shareKey = shareKeyObj
      if (shareKeyObj instanceof Array) {
        const newShareObj = shareKeyObj.filter(v => v)
        if (newShareObj && newShareObj.length > 0) {
          shareKey = newShareObj[newShareObj.length - 1]
        }
      } else if (shareKeyObj === 'undefined') {
        shareKey = ''
      }
      shareKey = shareKey.toString()

      // 以前shareKey 优先赋非空inviteCode，若空赋非空shareKey本身，以下可能针对有inivitCode 工号重复的处理(场景原因不详)
      // shareKey现已不掺inviteCode，后期替换为 inviteCodeDistinct
      if (
        shareKey.length === 16 &&
        isFinite(shareKey) &&
        shareKey.substr(0, 8) === shareKey.substr(-8)
      ) {
        // 邀请码育儿顾问工号出现重复的情况
        shareKey = shareKey.substr(0, 8)
      }

      let source = 1
      if (this.$$isHZWApp()) {
        source = 2
      } else if (this.$$isCZJApp()) {
        source = 1
      } else if (this.$$isRkhy()) {
        source = 3
      } else if (await isMiniprogram()) {
        const miniAppId = this.$$cookie('miniprogramid')
        if (MINI_APPID_XYZHG === miniAppId) {
          source = 14
        } else if (MINI_APPID_TCHQZ === miniAppId) {
          source = 15
        } else {
          source = 9
        }
      } else if (isWeixin) {
        source = 8
      }

      const extInfo = []

      const ycq = this.depList.find(item => item.id === 'ycq')
      if (ycq && ycq.value) {
        extInfo.push({
          labelName: '服务时间',
          labelKey: 'serviceTime',
          labelValue: ycq.value
        })
      }

      const liveid = this.$$cookie('liveid')
      const livestore = this.$$cookie('livestore')
      if (liveid) {
        extInfo.push({
          labelName: '直播间ID',
          labelKey: 'liveid',
          labelValue: liveid
        })
      }
      if (livestore) {
        extInfo.push({
          labelName: '设备ID',
          labelKey: 'livestore',
          labelValue: livestore
        })
      }

      // 地址信息
      let deliveryAddr = null

      deliveryAddr = {
        reqParam: {
          address: `${this.selectedAddress.province}${this.selectedAddress.city}${this.selectedAddress.district}${this.selectedAddress.address}`,
          province: this.selectedAddress.province,
          city: this.selectedAddress.city,
          regionid: this.selectedAddress.regionid,
          district: this.selectedAddress.district,
          name: this.selectedAddress.name,
          mobile: this.selectedAddress.mobile,
          addrid: this.selectedAddress.addrid,
          property: 1
        },
        moduleId: '1'
      }

      /* eslint-disable */
      const params = {
        uid,
        skey,
        skuId: this.product.skuInfo.skuId,
        orderPrice: this.commonPrice, // 订单金额
        payPrice: this.commonPrice, // 实付金额
        couponPwd: this.selectedCoupon.couponPassword || "", // 优惠券码
        remark: this.remark || "", // 备注
        orderSource: source, // 订单来源1-APP 8-h5
        collectInfo: {
          deliveryAddr
        },
        extInfo,
        channelType: 1, // 订单类型1、系统下单 2、一元购下单 3、抢购下单 4、团购下单 5、积分下单(必填)
        shareKey, // 分享key
        num: 1, // 下单份数
        serviceCode: this.$route.query.workerCode,
        inviteCode: this.inviteCode.trim() || "",
        promotionGiveVoList:this.promotionGiveVoList,
        isPayPeriod:0
      };
      if (this.selectedCoupon.couponPassword) {
        const tempPrice = this.commonPrice - this.selectedCoupon.couponAmount;
        params.payPrice = tempPrice >= 0 ? tempPrice : 0;
      }

      if (!this.isAllPayType) {
        params.isPayPeriod = 1
        params.payPeriodVo = {
          preOrderPrice:this.product.skuInfo.payPeriodInfo.paymentDepositPrice,
          prePayPrice:this.product.skuInfo.payPeriodInfo.paymentDepositPrice,
          endOrderPrice:this.product.priceInfo.price - this.product.skuInfo.payPeriodInfo.paymentDepositPrice,
          endPayPrice:params.payPrice-this.product.skuInfo.payPeriodInfo.paymentDepositPrice
        }
      }
      // console.log(params)
      const res = await this.$store.dispatch("createOrder", params);
      const order_res = res.data || {};
      // 因为付款成功之后需要使用母订单订单号查看订单详情，顾存在localStorage里边
      // localStorage.setItem('parentOrderId',order_res.orderId)
      setOrderId(order_res.orderId)
      this.fetching = false;
      if (order_res.orderId) {
        this.$$cookie.remove("liveid");
        this.$$cookie.remove("livestore");
        this.gotoCashier(order_res.state * 1, order_res.payOrderId?order_res.payOrderId:order_res.orderId);
        if (this.$$getDevice() === "ios" || this.$$getDevice() === "android") {
          const leftCoupon = this.couponList.filter(
            ele => ele.Code !== this.selectedCoupon.Code
          );
          this.$store.commit("setCouponList", leftCoupon);
          this.$store.commit("setSelectedCoupon", {});
        }
      } else if (res.code === "4") {
        this.$$login();
      } else {
        this.$$toast(res.msg);
      }
    },
    // 月嫂预下单（仅对 签约月嫂） 可能不用了
    gotoCashier(state, orderId) {
      let url = "";
      if (state === 2) {
        //不需要支付
        url = `${this.$$hostname(
          "life"
        )}/v/order/pay-success?orderCode=${orderId}&cmd=share&sharetype=0&refresh=no`;
      } else {
        let cashierUrl = `${this.$$hostname(
          "cashier"
        )}/query/${orderId}?partnerid=3004&dealcode=${orderId}&platformid=2`;
        if (this.$$isHZWApp()) {
          cashierUrl += "&cmd=khzwcashier";
        } else {
          cashierUrl += "&cmd=share&sharetype=0";
        }
        url = `${cashierUrl}&uid=${this.$$cookie("uid")}&skey=${this.$$cookie(
          "skey"
        )}`;
      }
      const str = `uid: ${this.$$cookie("uid")}, link: ${encodeURIComponent(
        url
      )}`;
      this.$store.dispatch("sendLog", str);
      location.href = url;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixin";

.actionbar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  background: #fff;
  min-height: rem(100px);
  .action-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    height: 1rem;
    padding: 0 rem(24px);
  }
  .action-others {
    display: flex;
    align-items: center;

    li {
      flex: 1;
      flex-basis: 0;
      font-size: rem(24px);
      display: flex;
      align-items: center;
      line-height: rem(56px);

      p {
        color: #ff5900;
        font-weight: 500;

        i {
          font-size: rem(24px);
        }
        span {
          padding-left: rem(4px);
          font-size: rem(40px);
        }
      }
    }
  }
  .action-prepay{
    display: flex;
    flex-direction: column;
    .prepay {
      span {
        font-size: rem(26px);
        color: #000000;
      }
      span:last-child {
        font-weight: 500;
        font-size: rem(36px);
        color: #FF5900;
      }
    }
    .nextpay {
      padding-top: rem(7px);
      font-size: rem(20px);
      color: #FF8800;
    }
  }
  .btns {
    display: block;
    flex: none;
    width: rem(208px);
    text-align: center;
    line-height: rem(72px);
    color: #fff;
    font-size: rem(26px);

    border-radius: rem(40px);
  }
  .btn-pink {
    background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
  }
  .btn-grey {
    background: #ccc;
  }
}
</style>
<style>
.mint-msgbox-message.mint-msgbox-message {
  line-height: 1.5;
}
</style>
